import { TRUNCATE_FILE_NAME_MAX_LENGTH } from "./strings";

export const truncateFileName = (name, maxLength = TRUNCATE_FILE_NAME_MAX_LENGTH) => {
  if (!name) {
    return "";
  }
  return name.length > maxLength ? name.substring(0, maxLength) + "..." : name;
};

export const transformQueries = (query) =>
  query.reduce((acc, { key, label }) => {
    acc[Number(key)] = label;
    return acc;
  }, {});
